
define(['jquery', 'underscore', 'require', 'core', 'app-common/lib/jquery.velocity'], function($, _, require, core) {
  var menu;
  menu = [];
  return {
    start: function() {
      var features, menuContainer, menuTemplate, settingsModel, template, userRoles, widgets;
      userRoles = core.getCurrentClientRoles();
      $('#sidebar').velocity('transition.fadeIn', 400);
      menuContainer = $('.sidebar-inner');
      menuTemplate = require('text!' + core.getConfig().sidebarMenuTemplate);
      widgets = $.extend(true, [], core.getConfig().widgets);
      settingsModel = core.getModel('clientsettings');
      features = (settingsModel != null ? settingsModel.get('features') : void 0) || {};
      menu = _.chain(widgets).filter(function(section) {
        return section.items != null;
      }).map(function(section) {
        var items;
        items = _.chain(section.items).filter(function(item) {
          return hasAccess(item, userRoles);
        }).filter(function(item) {
          if (core.getFeatureFlagValue == null) {
            return true;
          }
          if ((item != null ? item.disableWithFeatureFlag : void 0) && (typeof core.getFeatureFlagValue === "function" ? core.getFeatureFlagValue(item != null ? item.disableWithFeatureFlag : void 0) : void 0) === true) {
            return false;
          }
          return typeof core.getFeatureFlagValue === "function" ? core.getFeatureFlagValue(item != null ? item.enableWithFeatureFlag : void 0) : void 0;
        }).map(function(item) {
          return _.extend(item, {
            id: item.id,
            url: core.getRouter().buildUrl(item.id)
          });
        }).value();
        return _.extend(section, {
          items: items
        });
      }).filter(function(section) {
        return section.items.length > 0;
      }).value();
      template = _.template(menuTemplate, {
        menu: menu
      });
      menuContainer.append(template);
      return menuContainer.find('.main-nav-list li').not('.active-pointer').not(':hidden').velocity('stop').velocity('transition.slideLeftIn', {
        duration: 400,
        stagger: 50
      });
    },
    setMenuItemActive: function(widgetId) {
      var activeItem;
      $('.menu-item').removeClass('active');
      activeItem = $("#" + widgetId + "-menu-item");
      if (!activeItem.length) {
        return;
      }
      return activeItem.addClass('active');
    },
    getMenuObject: function() {
      return menu;
    },
    getMenuItemById: function(itemId) {
      var item, section, _i, _j, _len, _len1, _ref;
      for (_i = 0, _len = menu.length; _i < _len; _i++) {
        section = menu[_i];
        _ref = section.items;
        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
          item = _ref[_j];
          if (itemId === item.id) {
            return item;
          }
        }
      }
      return {};
    }
  };
});
